import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n/config';
import './LanguageSwitcher.css';

/**
 * The flag emoji this used to show (🇬🇧 / 🇪🇸) are regional-indicator pairs,
 * which Chrome on Linux and most Windows builds render as two letter boxes
 * rather than a flag. The language code carries the same meaning and always
 * renders, so it is now the whole control.
 */
function LanguageSwitcher({ inline = false }) {
  const { t, i18n } = useTranslation();

  return (
    <div className={`language-switcher ${inline ? 'language-switcher--inline' : ''}`} role="group" aria-label={t('language.label')}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`language-switcher__button ${i18n.language === lng ? 'active' : ''}`}
          onClick={() => i18n.changeLanguage(lng)}
          aria-pressed={i18n.language === lng}
          aria-label={t(`language.${lng}`)}
        >
          <span className="language-switcher__code">{lng.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
